import React from "react"
import LowerHeaderWrapper from "../../../components/LowerHeaderWrapper"
import BackToSiteBanner from "../../../components/BackToSiteBanner"
import CookieConsent from "../../../components/CookieConsent"
import WidescreenCookieConsent from "../../../components/WidescreenCookieConsent"
import CountryChangeConfirmPopup from "../../../components/CountryChangeConfirmPopup"
import {HeaderContainer, InnerContainer} from "./components"
import Brand from "../../../components/Brand"
import {SearchSmallScreen, SearchBigScreen} from "../../../components/Search"
import MyAccount from "../../../components/MyAccount"
import QuickLinksContainer from "../../../components/QuickLinksContainer"
import Favourites from "../../../components/Favourites"
import ShoppingBag from "../../../components/ShoppingBag"
import Checkout from "../../../components/Checkout"
import {
    HEADER_NAV_BAR_QUICK_LINKS,
    HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT,
    COUNTRY_SELECTOR_DRAWER_BREAKPOINT,
} from "../../../config/constants"
import CountryLangSelector from "../../../components/CountryLangSelector"
import TestTools from "../../../components/TestTools"
import TimeMachineDate from "../../../components/TimeMachineDate"
import UpperHeaderWrapper from "../../../components/UpperHeader"
import SaleBagWarningModal from "../../../components/SaleBagWarningModal"
import StaticHeaderBanner from "../../../components/StaticHeaderBanner"
import PrimaryNav from "../../../components/PrimaryNav"
import SecondaryNav from "../../../components/SecondaryNav"
import {useMediaQuery} from "../../../hooks/useMediaQuery"
import SecureIcon from "../../../components/SecureIcon"
import HelpLink from "../../../components/SecureHelpLink"
import SecureHeaderWrapper from "../../../components/SecureHeaderWrapper"

export interface StandardHeaderProps {
    closeModalHandler: () => void
    enableCookieConsent: boolean
    showCheckoutButton: boolean
    showModal: boolean
    showSaleWarningBag: boolean
    showStaticHeaderBanner: boolean
    displayTestTools: boolean
    textAlignment: string
    useDevEsi: boolean
    widescreenCookieConsent: boolean
    isSecure: boolean
}

export const StandardHeaderComposition = ({
    closeModalHandler,
    enableCookieConsent,
    showCheckoutButton,
    showModal,
    showSaleWarningBag,
    showStaticHeaderBanner,
    displayTestTools,
    textAlignment,
    widescreenCookieConsent,
    isSecure,
}: StandardHeaderProps) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isOpeningFromBottom = !useMediaQuery(`(min-width:${COUNTRY_SELECTOR_DRAWER_BREAKPOINT})`)
    return isSecure ? (
        <header dir={textAlignment}>
            <SecureHeaderWrapper>
                <InnerContainer>
                    <Brand tabbedNavigationEnabled={false} />
                    <SecureIcon />
                    <HelpLink />
                    <ShoppingBag
                        tooltipModifiers={[
                            {
                                name: "offset",
                                options: {
                                    enabled: true,
                                    offset: [0, 7],
                                },
                            },
                        ]}
                        isSecure
                    />
                    <CountryLangSelector isOpeningFromBottom={isOpeningFromBottom} />
                </InnerContainer>
                {enableCookieConsent && (widescreenCookieConsent ? <WidescreenCookieConsent /> : <CookieConsent />)}
            </SecureHeaderWrapper>
        </header>
    ) : (
        <HeaderContainer dir={textAlignment}>
            <BackToSiteBanner />
            <UpperHeaderWrapper>
                {showStaticHeaderBanner && <StaticHeaderBanner />}
                <InnerContainer>
                    <Brand tabbedNavigationEnabled={false} />
                    <SearchBigScreen />
                    <SearchSmallScreen />
                    <MyAccount />
                    <QuickLinksContainer containerStyles={{display: {lg: "block", md: "none", xs: "none"}}} />
                    <Favourites anchorStyles={{display: {xs: "flex"}}} />
                    <ShoppingBag
                        applyMarginCompensation
                        tooltipModifiers={[
                            {
                                name: "offset",
                                options: {
                                    enabled: true,
                                    offset: [0, 10],
                                },
                            },
                        ]}
                    />
                    {showCheckoutButton && (
                        <Checkout
                            dataGaV1={HEADER_NAV_BAR_QUICK_LINKS}
                            dataGaV2={HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT}
                        />
                    )}
                    <CountryLangSelector isOpeningFromBottom={isOpeningFromBottom} applyMarginCompensation />
                    {displayTestTools && <TestTools />}
                    <TimeMachineDate />
                    {showSaleWarningBag && <SaleBagWarningModal />}
                </InnerContainer>
            </UpperHeaderWrapper>
            <LowerHeaderWrapper>
                <PrimaryNav />
                <SecondaryNav />
            </LowerHeaderWrapper>
            {showModal && <CountryChangeConfirmPopup showModal={showModal} closeModal={closeModalHandler} />}
            {enableCookieConsent && (widescreenCookieConsent ? <WidescreenCookieConsent /> : <CookieConsent />)}
        </HeaderContainer>
    )
}
export default StandardHeaderComposition
